import styled from 'styled-components';

export const SFormSection = styled.div`
  margin-bottom: 15px;
`;

export const SButtonsSection = styled.div`
  padding-top: 15px;
`;
